<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات نمایشگاه"
        >
          <b-form
              ref="exhibitionform"
              @submit.prevent
          >
            <b-row>

              <b-col
                  class="mt-2"
                  md="6"
                  offset-md="3"
              >
                <b-row>

                  <b-col
                      class="image"
                      cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                            ref="previewEl"
                            :src="Form.Image"
                            size="90px"
                            rounded
                            button
                            @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                          :ref="'refInputEl'"
                          type="file"
                          class="d-none"
                          name="Image"
                          @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                              label="عنوان"
                              label-for="Title"
                              class="mb-0"
                          >
                            <b-form-input
                                id="Title"
                                v-model="Form.Title"
                                name="Title"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="پیوند یکتا"
                        label-for="Slug"
                    >
                      <b-form-input
                          id="Sort"
                          v-model="Form.Slug"
                          name="Slug"
                          autocomplete="off"
                          dir="ltr"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="تاریخ شروع"
                        label-for="StartDate"
                    >
                      <date-picker
                          v-model="Form.StartDate"
                          placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="تاریخ پایان"
                        label-for="EndDate"
                    >
                      <date-picker
                          v-model="Form.EndDate"
                          placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="استان"
                        label-for="StateId"
                    >
                      <z-state v-model="Form.StateId" :clearable="false" />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="شهر"
                        label-for="CityId"
                    >
                      <z-city v-model="Form.CityId" :state-id="Form.StateId" />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="محل برگزاری"
                        label-for="Venue"
                    >
                      <b-form-input
                          id="Venue"
                          v-model="Form.Venue"
                          autocomplete="off"
                          name="Venue"
                      />
                    </b-form-group>
                  </b-col>


                  <b-col md="6">
                    <b-form-group
                        label="رنگ"
                        label-for="ColorId"
                    >
                      <z-color v-model="Form.ColorId" />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="وضعیت"
                        label-for="IsActive"
                    >
                      <v-select
                          v-model="Form.IsActive"
                          :options="enums('IsActive')"
                          dir="rtl"
                          label="text"
                          :clearable="false"
                          :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="توضیحات"
                        label-for="Description"
                    >
                      <b-form-textarea
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          rows="5"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        type="submit"
                        variant="primary"
                        class="mr-1"
                        @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZState from "@/tools/state.vue";
import ZCity from "@/tools/city.vue";
import ZColor from "@/tools/color.vue";

export default {
  name: 'ExhibitionDetails',
  components: {
    ZState,
    ZCity,
    ZColor,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        CityId: null,
        StateId: null,
        IsActive: true,
        StartDate: null,
        EndDate: null,
        Description: null,
        ColorId: null,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.exhibition.add
      if (this.$route.params.id) {
        url = this.$api.exhibition.update
      }

      const formData = new FormData(this.$refs.exhibitionform)

      if (this.Form.StartDate) {
        formData.append('StartDate', this.Form.StartDate)
      }

      if (this.Form.EndDate) {
        formData.append('EndDate', this.Form.EndDate)
      }

      if (this.Form.ColorId) {
        formData.append('ColorId', this.Form.ColorId)
      }

      if (this.Form.CityId) {
        formData.append('CityId', this.Form.CityId)
      }

      formData.append('IsActive', this.Form.IsActive)
      formData.append('Id', this.Form.Id)

      this.loading = true
      this.$http.post(
          url, formData,
      )
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.exhibition.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
            this.Form.StateId = this.Form.City.StateId
            console.log()
          })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
